<template>
  <div class="partner-modal">
    <div class="error-modal-body">
      <div class="row">
        <div class="col-md-12 title">
          <p>Хамтран нэмэх</p>
          <button @click.esc="close">x</button>
        </div>
        <div class="col-md-12 box-text">
          <div class="row">
            <div class="col-md-6">
              <h2>Хамтрангаар нэмэх карт №</h2>
            </div>
          </div>
        </div>
        <div class="col-md-12 box-text">
          <div class="row">
            <div class="col-md-6">
              <input
                type="text"
                class="form-control"
                v-model="cardId"
                placeholder="Карт / утасны дугаар"
                @change="getCustomerInfo"
                autofocus
                required
              />
            </div>
          </div>
        </div>
        <div class="col-md-12 box-text" style="margin-top: 10px">
          <div class="row">
            <div class="col-md-6">
              <input
                type="text"
                class="form-control"
                v-model="userName"
                placeholder="Карт эзэмшигчийн мэдээлэл"
                readonly
              />
            </div>
            <div class="col-md-3">
              <button
                class="btn"
                @click.esc="checkPartner"
                :disabled="inProcess"
              >
                Хүсэлт илгээх
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-12 box-text" style="margin-top: 10px">
          <div class="row">
            <div class="col-md-6">
              <input
                type="text"
                class="form-control"
                v-model="confirmCode"
                placeholder="Баталгаажуулах код оруулах"
                required
              />
            </div>
          </div>
        </div>
        <p
          v-if="errorModal"
          style="color: red; text-align: center; margin-left: 50px"
        >
          {{ errorMessage }}
        </p>
        <div class="col-md-12 box-text top20">
          <div class="row">
            <div class="col-md-12 text-center">
              <button class="btn" @click.esc="setPartner" :disabled="inProcess">
                Хамтран болох
              </button>
              <button class="btn redColor" @click.esc="close">Болих</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      inProcess: false,
      type: "All",
      userName: "",
      partCardHolderKey: "",
      confirmCode: "",
      cardId: "",
      isSelected: false,
      errorMessage: "",
      errorModal: true,
    };
  },
  methods: {
    setPartner() {
      this.inProcess = true;
      this.$auth.setPartnerPinCode(this.confirmCode);
      this.$emit("setPartner");
    },
    checkPartner() {
      if (this.isSelected === false) {
        alert("Хамтран болох хүнээ сонгоно уу");
        return;
      }
      var user = this.$auth.getMe();
      this.$internalApi
        .post(
          `card-relate/otp`,
          {
            cardNumber: user.cardHolderInfId,
            relateCardNumber: this.partCardHolderKey,
            systemId: "Web",
          },
          {
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": "mn",
            },
          }
        )
        .then((response) => {
          var data = response.data;
          if (response.status === 200) {
            this.pinCode = data.pinCode;
            alert("Амжилттай илгээлээ");
          } else {
            alert(data.message);
          }
        })
        .catch((error) => {
          this.errorModal = true;
          this.errorMessage = error.response.data.message;
          this.isSelected = false;
        });
    },
    getCustomerInfo() {
      this.$loading(true);
      var cardNumberPhone = this.cardId;
      var isnum = /^\d+$/.test(cardNumberPhone);
      let searchType = this.type;
      if (isnum && cardNumberPhone.length > 0) {
        var tokenId = localStorage.getItem("authToken");
        var user = this.$auth.getMe();
        if (tokenId == null || user == null) {
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        }
        var cardHolderInfId = user.cardHolderInfId;
        if (cardHolderInfId === cardNumberPhone) {
          this.errorModal = true;
          this.errorMessage = "Өөрийгөө хамтрангаар нэмэх боломжгүй.";
          this.$loading(false);
          this.cardId = "";
          this.userName = "";
          return;
        }
        this.$auth.removeCustomerInfo();
        this.error = false;
        this.$bonusApi
          .post(`bonus-card/customer-info`, {
            // tokenId,
            cardNumberPhone,
            cardHolderInfId,
            searchType,
          })
          .then((response) => {
            var data = response.data;
            if (response.data.status === 0) {
              var cardHolderInfId = user.cardHolderInfId;
              if (cardHolderInfId == data.cardHolderInfId) {
                this.errorModal = true;
                this.errorMessage = "Өөрийгөө хамтрангаар нэмэх боломжгүй.";
                this.$loading(false);
                this.cardId = "";
                this.userName = "";
                this.isSelected = false;
              } else if (data.firstName == "" || data.lastName == "") {
                this.errorModal = true;
                this.errorMessage =
                  "Карт эзэмшигчийн мэдээлэл баталгаажаагүй байна.";
                this.$loading(false);
                this.cardId = "";
                this.userName = "";
                this.isSelected = false;
              } else {
                this.$auth.setPartnerCardHolderKey(data.cardHolderInfId);
                this.partCardHolderKey = data.cardHolderInfId;
                this.userName = data.firstName + " " + data.lastName;
                this.$auth.setCustomerInfo(data);
                this.isSelected = true;
                this.errorModal = false;
                this.errorMessage = "";
              }
            } else if (response.data.status === 1) {
              this.showOverlap = true;
              return;
            } else {
              this.errorModal = true;
              this.errorMessage = data.message;
              this.cardId = "";
              this.userName = "";
              this.isSelected = false;
            }
          })
          .catch((error) => {
            this.errorModal = true;
            this.errorMessage = error.response.data.message;
            this.isSelected = false;
          });
      } else {
        alert("Та зөвхөн тоо оруулна уу ?");
      }
      this.$loading(false);
    },
    close() {
      this.$emit("hidePartnerModal");
    },
    hideErrorMessage() {
      (this.errorMessage = ""), (this.errorModal = false);
    },
  },
};
</script>
<style scoped>
.partner-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  z-index: 10;
  padding: 0;
  margin: 0;
}
.error-modal-body {
  position: absolute;
  top: 15%;
  width: 600px;
  box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.15);
  border-radius: 14px;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0;
  margin: 0;
  padding-bottom: 30px;
}
.title {
  float: left;
}
.title p {
  padding: 8px 0;
  margin: 0;
  color: #fff;
  background-color: #1660ab;
  border-top-right-radius: 14px;
  border-top-left-radius: 14px;
  padding-left: 22px;
}
.title button {
  top: 6px;
  right: 24px;
  position: absolute;
  background: none;
  border: none;
  color: #fff;
}
.box-text {
  padding-left: 40px;
}
.box-text p {
  padding: 10px 0;
  margin: 0;
  border: none;
  color: #7e7e7e;
}
.box-text h2 {
  padding: 10px 0;
  font-size: 16px;
  margin: 0;
  color: #1660ab;
  font-weight: 500;
  border: none;
}
.error-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  z-index: 2000;
}
.btn {
  background-color: #1660ab;
  color: #fff;
  padding: 3px 50px;
  margin-left: 16px;
  line-height: 0.9;
}
.btn.redColor {
  background-color: #ed3237;
}
.top20 {
  margin-top: 20px;
}
.error-modal-body .error-error {
  margin-top: 37px !important;
  font-size: 13px;
  width: 306px;
  padding-left: 18px;
  line-height: 1.38;
  flex: 5;
  height: 49px;
  color: rgba(0, 0, 0, 0.8);
  margin: 0;
  text-align: left;
}
.error-modal-body div p {
  margin: 0;
}
.error-modal-body .error-img {
  margin-top: 37px !important;
  height: 49px;
  flex: 0.5;
  padding-left: 18px;
  line-height: 1.38;
}
.error-modal-body .error-close {
  width: auto;
  margin-top: 21px !important;
  height: 49px;
  padding-right: 18px;
  color: #fff;
}
.error-modal-body img {
  width: 100%;
  cursor: pointer;
}
.error-modal-body .error-message-icon {
  margin-top: 37px;
  height: 49px;
  flex: 0.8;
  font-size: 38px;
  color: #fff;
  padding-left: 24px;
  display: flex;
  justify-content: flex-end;
}
.error-modal-body .error-message-btn {
  margin-top: 25px;
  height: 49px;
  flex: 0.8;
  font-size: 18px;
  color: #fff;
  padding-right: 18px;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
}
.exitBtn {
  top: 0;
  right: 0;
  color: #fff;
  width: 32px;
  height: 32px;
  position: absolute;
}
@media screen and (max-width: 500px) {
  .error-modal-body {
    margin-top: 20%;
  }
}
@media screen and (max-width: 800px) {
  .error-modal-body {
    margin-top: 20%;
    width: 80%;
  }
  .box-text {
    padding-left: 30px;
  }
}
.bonus-transfer {
  margin: 0;
  padding: 10px 14px;
  border: 1px dashed #bdbdbd;
  margin-top: 14px;
}
.bonus-transfer p {
  margin: 0;
  font-size: 12px;
}
.colorRed {
  color: #ed3237;
}
.bonus-transfer b {
  color: #1660ab;
}
@media screen and (max-width: 767px) {
  .error-modal-body {
    width: 90%;
    top: 0;
  }
  .col-md-4 {
    max-width: 33.333333%;
  }
  .col-md-8 {
    max-width: 66.666667%;
    padding-left: 10px;
  }
  .box-text h2 {
    font-size: 12px;
  }
  .box-text p {
    font-size: 12px;
  }
  .btn {
    padding: 5px 10px;
    font-size: 14px;
  }
}
</style>
